import request from '@/utils/request'

// 投放组列表
export function listquick_release_groups(params = {}) {
  return request({
    url: '/quick_report/quick_release_groups',
    method: 'get',
    params
  })
}
// 投放组添加
export function addquick_release_groups(data = {}) {
  return request({
    url: '/quick_report/quick_release_groups',
    method: 'post',
    data
  })
}
// 投放组修改
export function editquick_release_groups(data = {}) {
  return request({
    url: `/quick_report/quick_release_groups/${data.id}`,
    method: 'put',
    data
  })
}
// 投放组删除
export function deletequick_release_groups(id = {}) {
  return request({
    url: `/quick_report/quick_release_groups/${id}`,
    method: 'DELETE'
  })
}
// 投手列表
export function listrelease_group_user(params = {}) {
  return request({
    url: '/quick_report/release_group_user',
    method: 'get',
    params
  })
}
// 选择用户列表
export function userrelease_group_leader(params = {}) {
  return request({
    url: '/quick_report/release_group_leader',
    method: 'get',
    params
  })
}
// 添加投手
export function release_group_user_add(data = {}) {
  return request({
    url: '/quick_report/release_group_user_add',
    method: 'post',
    data
  })
}
// 删除投手
export function release_group_user_del(params = {}) {
  return request({
    url: '/quick_report/release_group_user_del',
    method: 'DELETE',
    params
  })
}
// 书籍列表
export function belong_list(params = {}) {
  return request({
    url: '/quick_report/belong_list',
    method: 'get',
    params
  })
}
// 书籍添加
export function add_belong_book(data = {}) {
  return request({
    url: '/quick_report/add_belong_book',
    method: 'post',
    data
  })
}
// 书籍修改
export function update_belong_book(data = {}) {
  return request({
    url: '/quick_report/update_belong_book',
    method: 'put',
    data
  })
}

// 书籍删除
export function del_belong_book(params = {}) {
  return request({
    url: '/quick_report/del_belong_book',
    method: 'DELETE',
    params
  })
}
// 绑定列表
export function quick_binds(params = {}) {
  return request({
    url: '/quick_report/quick_binds',
    method: 'get',
    params
  })
}
// 绑定关系添加
export function addquick_binds(data = {}) {
  return request({
    url: '/quick_report/quick_binds',
    method: 'post',
    data
  })
}
// 绑定关系修改
export function editquick_binds(id, data = {}) {
  return request({
    url: `/quick_report/quick_binds/${id}`,
    method: 'put',
    data
  })
}
// 绑定关系删除
export function delquick_binds(id) {
  return request({
    url: `/quick_report/quick_binds/${id}`,
    method: 'DELETE'
  })
}
// 每日列表
export function bind_quick_report(params = {}) {
  return request({
    url: 'quick_report/bind_quick_report',
    method: 'get',
    params
  })
}
// 总计列表
export function total_quick_report(params = {}) {
  return request({
    url: 'quick_report/total_quick_report',
    method: 'get',
    params
  })
}
// 修改消耗
export function set_consume(data = {}) {
  return request({
    url: 'quick_report/set_consume',
    method: 'put',
    data
  })
}
// 平台
export function channel_platform_list(params = {}) {
  return request({
    url: '/common/channel_platform_list',
    method: 'get',
    params
  })
}
// 批量导入关系
export function import_bind(data = {}) {
  return request({
    url: '/quick_report/import_bind',
    method: 'post',
    data
  })
}
// 批量导入消耗
export function import_consume(data = {}) {
  return request({
    url: '/quick_report/import_consume',
    method: 'post',
    data
  })
}
